<template>
    <modal id="address-modal" v-model="showModal" size="large" :title="generateModalTitle('address')" @submit="submitData"
        :loading="loading" :preloader="preloader">
        <form v-if="!loading" ref="form" :data-url='selectedUrl ? selectedUrl : ADDRESS' @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-12">
                    <app-form-group :label="$t('Address Title')" type="radio" radio-checkbox-name="addr_title" :list="[
                        { id: 'na', value: $t('NA'), disabled: addressHasData() },
                        { id: 'home', value: $t('home') },
                        { id: 'work', value: $t('work') },
                        { id: 'other', value: $t('Other') }
                    ]" v-model="formData.name" :error-message="$errorMessage(errors, 'name')" />
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12">
                    <app-form-group :label="$t('Line 1')" v-model="formData.line_1" :disabled="formData.name === 'na'"
                        :required="formData.name !== 'na'" :placeholder="$placeholder($t('Line 1'))"
                        :error-message="$errorMessage(errors, 'line_1')" />
                </div>
                <div class="col-md-12">
                    <app-form-group :label="$t('Line 2')" v-model="formData.line_2" :disabled="formData.name === 'na'"
                        :placeholder="$placeholder($t('Line 2'))" />
                </div>
                <div class="col-md-12">
                    <app-form-group :label="$t('Line 3')" v-model="formData.line_3" :disabled="formData.name === 'na'"
                        :placeholder="$placeholder($t('Line 3'))" />
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-6">
                    <label>{{ $t('country') }}</label>
                    <app-input type="select" :list="countryList" :key="countryList.length" list-value-field="name"
                        v-model="formData.country_id" :disabled="formData.name === 'na'" :error-message="$errorMessage(errors, 'country')" />
                </div>
                <div class="col-md-6">
                    <label>{{ $t('state') }}</label>
                    <app-input type="select" :list="statesList" :key="statesList.length" list-value-field="value"
                        v-model="formData.area" :disabled="formData.name === 'na'" :error-message="$errorMessage(errors, 'state')" />
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-6">
                    <app-form-group :label="$t('city')" :placeholder="$placeholder('city')" v-model="formData.city"
                        :disabled="formData.name === 'na'" :required="formData.name !== 'na'"
                        :error-message="$errorMessage(errors, 'city')" />
                </div>
                <div class="col-md-6">
                    <app-form-group :label="$t('Pin Code')" :placeholder="$placeholder('zip_code')"
                        v-model="formData.zip_code" type="number" :disabled="formData.name === 'na'"
                        :required="formData.name !== 'na'" :error-message="$errorMessage(errors, 'zip_code')" />
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import DefaultAction from "../../../../../core/components/datatable/DefaultAction";
import { ADDRESS } from "../../../../Config/ApiUrl-CPB";
import { COUNTRIES, SELECTABLE_STATES } from "../../../../Config/ApiUrl-CP";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary";
import { axiosGet, urlGenerator } from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "AddressModal",
    extends: CoreLibrary,
    mixins: [FormHelperMixins, ModalMixin],
    components: {
        DefaultAction,
    },
    props: {
        userId: {},
        userType: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            customerData: '',
            ADDRESS,
            COUNTRIES,
            isModalActive: false,
            countryOptions: {
                url: urlGenerator("app/selectable-countries"),
                query_name: "search_by_name",
                per_page: 10,
                loader: "app-pre-loader", // by default 'app-overlay-loader'
                modifire: ({ id, name: value }) => ({ id, value }),
            },
            formData: {
                customer_id: this.userType === 'customer' ? this.userId : '',
                country_id: '',
                supplier_id: this.userType === 'supplier' ? this.userId : '',
                name: 'na',
                line_1: '',
                line_2: '',
                line_3: '',
                address_type: '',
            },
            countryList: [],
            statesList: [],
        }
    },
    methods: {
        addressHasData() {
            const a = this.formData || {};
            return !!(a.line_1 || a.line_2 || a.line_3 || a.city || a.zip_code);
        },
        submitData() {
            this.formData.details = [this.formData.line_1, this.formData.line_2, this.formData.line_3].filter(Boolean).join(', ') || this.formData.details || '';
            this.fieldStatus.isSubmit = true;
            this.loading = true;
            this.message = '';
            this.errors = {};
            this.save(this.formData);
        },
        // getCountries() {
        //     axiosGet("app/selectable-countries")
        //         .then(data => this.countryList = [{ name: this.$t('select_country') }, ...data.data]);
        // },
        getCountries() {
            axiosGet("app/selectable-countries")
                .then(data => {
                    this.countryList = [{ name: this.$t('select_country') }, ...data.data];

                    // Find the ID of the country "India" in the countryList
                    const indiaCountry = this.countryList.find(country => country.name === 'India');
                    if (indiaCountry) {
                        // Set the country_id for India
                        this.formData.country_id = indiaCountry.id;
                    } else {
                        console.log('India not found in country list.');
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        },
        statesOptions() {
            this.statesList.unshift({ id: '', value: 'Select State' });
            try {
                axiosGet(`${SELECTABLE_STATES}`).then(response => {
                    if(this.formData.stateid == '') this.formData.stateid = response.data.data[0].id;
                    for (let item of response.data.data) {
                        this.statesList.push({
                            id: item.id,
                            value: item.state,
                        });
                    }
                });
            } catch (error) {
                console.error(error);
            }
        },
        afterSuccess({ data }) {
            this.formData = {
                sales_person: []
            };
            $('#address-modal').modal('hide');
            this.$emit('input', false);
            this.$emit('reload');
            this.toastAndReload(data.message);
        },
        afterSuccessFromGetEditData(response) {
            this.formData = response.data;
            this.axiosGet("app/selectable-countries").then(res => this.countryList = res.data).finally(() => {
                this.preloader = false;
            })
        },
    },
    mounted() {
        this.getCountries();
        this.statesOptions();
    },
}
</script>
